import { Components, Theme } from '@mui/material'
import { colors } from '../constants'

const MuiLink: Components<Theme>['MuiLink'] = {
  styleOverrides: {
    root: {
      color: colors.teal[800],
      '&:hover': {
        color: colors.teal[300],
      },
      '&:hover, $focusVisible': {
        color: colors.teal[300],
      },
    },
  },
  defaultProps: {
    underline: 'none',
  },
}

export { MuiLink }
